import {Routes} from '@angular/router';
import {NotFoundComponent} from "./components/app/not-found/not-found.component";
import {ForecastPlanning} from './pages/forecast-planning/forecast-planning';
import {PlanningParameters} from './pages/planning-parameters/planning-parameters';
import {Containers} from './pages/containers/containers';
import {CustomFields} from './pages/custom-fields/custom-fields';
import {ForecastContainers} from './pages/forecast-containers/forecast-containers';
import {PurchaseOrders} from './pages/purchase-orders/purchase-orders';

export const routes: Routes = [
    {path: '', redirectTo: '/forecast-planning', pathMatch: 'full'},
    {
        path: 'forecast-planning',
        component: ForecastPlanning,
        title: 'Forecast Planning',
        data: {
            showInMenu: true,
            icon: 'forecast'
        }
    },
    {
        path: 'planning-parameters',
        component: PlanningParameters,
        title: 'Planning Parameters',
        data: {
            showInMenu: true,
            icon: 'settings'
        }
    },
    {
        path: 'containers',
        component: Containers,
        title: 'Containers',
        data: {
            showInMenu: true,
            icon: 'container'
        }
    },
    // { ==============================================> OBSOLETE
    //     path: 'add-container-information',
    //     component: AddContainerInformation,
    //     title: 'Add Container information',
    //     data: {
    //         showInMenu: true,
    //         icon: 'add'
    //     }
    // },
    {
        path: 'custom-fields',
        component: CustomFields,
        title: 'Custom Fields',
        data: {
            showInMenu: true,
            icon: 'sliders'
        }
    },
    {
        path: 'forecasts/:forecastId/containers',
        component: ForecastContainers,
        data: {
            showInMenu: false,
        }
    },
    {
        path: 'purchase-orders',
        component: PurchaseOrders,
        title: 'Purchase Orders',
        data: {
            showInMenu: true,
            icon: 'cartPlus'
        }
    },
    {path: '**', component: NotFoundComponent}
];
